module.exports = __webpack_public_path__ + "static/media/taipingshan_plant.0e45dcad.webp";